export class SelfTerminationClass {
    consumerId = 0;
    constructor(_consumerId){
        this.consumerId=_consumerId;
    }
    async terminateParticipant(data) {
        throw new Error("No TerminateParticipant method was defined");
    }
}